module.exports = __webpack_public_path__ + "img/bold-archive.838fcb06.svg";